<template>
<div class="ranking-list" ref="rankingbox">
    <!-- 排行前三部分 -->
    <div class="top-three-box">
        <p @click="goback" class="back"></p>
        <div class="top-pklogo"></div>
        <div @click="gopage" class="rewardrules-enter" alt=""></div>
        <div class="top-ranking">
          <div class="top-rankingItem" v-for="item in prizeList" :key="item.level">
            <img :src="item.coverImg" alt="">
            <p>{{item.prizeName}}</p>
          </div>
          <!-- <div class="top-rankingItem">
            <img src="../assets/img/jiangpin.png" alt="">
            <p><span>省级品鉴之星</span><span>51-300名</span></p>
          </div>
          <div class="top-rankingItem">
            <img src="../assets/img/jiangpin.png" alt="">
            <p><span>地区品鉴之星</span><span>301-3000名</span></p>
          </div> -->
        </div>
        <!-- <p class="top-one">
            <template v-if="list[0] && list[0].nums > 0">
                <img :src="list[0].coverImg || require('../assets/img/default-coverimg.png')" alt="">
                <p class="top-name">{{list[0].nickName || "用户" + list[0].openId.substring(list[0].openId.length-6)}}</p>
                <p class="top-nums">{{list[0].nums}}</p>
            </template>
            <template v-else>
                <p class="no-data">虚位以待</p>
            </template>
        </p>
        <p class="top-two">
            <template v-if="list[1] && list[1].nums > 0">
                <img :src="list[1].coverImg || require('../assets/img/default-coverimg.png')" alt="">
                <p class="top-name">{{list[1].nickName || "用户" + list[1].openId.substring(list[1].openId.length-6)}}</p>
                <p class="top-nums">{{list[1].nums}}</p>
            </template>
            <template v-else>
                <p class="no-data">虚位以待</p>
            </template>
        </p>
        <p class="top-three">
            <template v-if="list[2] && list[2].nums > 0">
                <img :src="list[2].coverImg || require('../assets/img/default-coverimg.png')" alt="">
                <p class="top-name">{{list[2].nickName || "用户" + list[2].openId.substring(list[2].openId.length-6)}}</p>
                <p class="top-nums">{{list[2].nums}}</p>
            </template>
            <template v-else>
                <p class="no-data">虚位以待</p>
            </template>
        </p> -->
    </div>

    <div class="ranking-box">
        <!-- 个人是否参与过排行，以及个人的排名 -->
        <div class='person-infos'>
            <!-- 未参与 -->
            <!-- <div class="uncommitted" v-if="uncommitted[0] && uncommitted[0].state == '0'">
                <img :src="uncommitted[0].coverImg || require('../assets/img/default-coverimg.png')" alt="">
                <span class="name">{{uncommitted[0].nickName || "用户" + openId.substring(openId.length-6)}}</span>
                <span class="tips">未参与PK赛，暂无排名</span>

            </div> -->
            <!-- 未参与 -->
            <div class="uncommitted" v-if="uncommitted[0] && uncommitted[0].state == '0'">
                <div class="activity-time">
                  <span v-if="acquisitionTime != 1">活动时间为 {{startTime[0]}}~{{endTime[0]}}</span>
                  <span v-if="acquisitionTime == 1" class="tips">未参与PK赛，暂无排名</span>
                  <span v-if="acquisitionTime == 1" class="join-btn" @click="popupShow">参与</span></div>
                <div class="division"></div>
                <div class="uncommitted-container">
                  <div class="ucontainer-left">
                    <img :src="uncommitted[0].coverImg || require('../assets/img/default-coverimg.png')" alt="">
                    <p class="name">{{uncommitted[0].nickName || "用户" + openId.substring(openId.length-6)}}</p>
                  </div>
                  <div class="ucontainer-right">
                    <p>
                      集星 | <span>-</span>
                    </p>
                    <p>
                      排行 | <span>-</span>
                    </p>
                  </div>
              </div>

                <!-- <span class="name">{{uncommitted[0].nickName || "用户" + openId.substring(openId.length-6)}}</span> -->
                <!-- <span class="tips">未参与PK赛，暂无排名</span> -->
                <!-- <span class="join-btn" @click="popupShow">参与</span> -->
            </div>
            <!-- 已参与 -->
             <div class="participated" v-if="uncommitted[0] && uncommitted[0].state != 0">
                <div class="participated-top">
                  <div v-if="acquisitionTime == 3 || acquisitionTime == 4">
                    <div class="activity-time">
                      <span>活动时间为 {{startTime[0]}}~{{endTime[0]}}</span>
                    </div>
                    <div class="division"></div>
                  </div>
                  <div class="pratLenf-Container" v-else>
                    <div class="partLeft">
                      <img src="../assets/img/jiangbei.png" alt="">
                      <span>{{uncommitted[0].rank}}</span>
                      <!-- <span v-if="uncommitted[0].orderNum >= 1 && uncommitted[0].orderNum < 51" >飞鹤中国品鉴之星</span>
                      <span v-else-if="uncommitted[0].orderNum > 50 && uncommitted[0].orderNum < 301" >飞鹤省级品鉴之星</span>
                      <span v-else-if="uncommitted[0].orderNum > 300 && uncommitted[0].orderNum < 3001" >飞鹤地区品鉴之星</span>
                      <span v-else >飞鹤品鉴官</span> -->
                    </div>
                    <div class="partRight" v-if="uncommitted[0].orderNum !== 1">
                    </div>
                    <p class="partRight-text" v-if="uncommitted[0].gap && list && uncommitted[0].orderNum !== 1">
                      <span v-if="uncommitted[0].orderNum > 1 && uncommitted[0].orderNum < 201" >距离第1名还需</span>
                      <span v-else-if="uncommitted[0].orderNum > 200 && uncommitted[0].orderNum < 1201" >距离第200名还需</span>
                      <span v-else-if="uncommitted[0].orderNum > 1200 && uncommitted[0].orderNum < 11201" >距离第1200名还需</span>
                      <span v-else-if="uncommitted[0].orderNum > 11200 && uncommitted[0].orderNum < 31201" >距离第11200名还需</span>
                      <span v-else>距离四等奖还需</span>
                      <span class="prize-num"> {{uncommitted[0].gap == 0 ? 1 : tranNumber(uncommitted[0].gap || 0, 1)}} </span>个赞
                    </p>
                    <p class="partRight-text" v-else>
                      <span>距离第1名还需1个赞</span>
                    </p>
                  </div>
                </div>
                <div class="division"></div>
                <div class="participated-bottom" >
                    <div class="participated-left">
                       <img :src="uncommitted[0].coverImg || require('../assets/img/default-coverimg.png')" alt="">
                      <p class="name">{{uncommitted[0].nickName || "用户" + openId.substring(openId.length-6)}}</p>
                    </div>
                    <div class="participated-right">
                      <span class="share-nums">集星 | {{uncommitted[0].nums ? tranNumber(uncommitted[0].nums || 0, 1) : '-'}}</span>
                      <span class="ranking-nums">排行 | {{uncommitted[0].orderNum ? tranNumber(uncommitted[0].orderNum || 0, 1) : '-'}}</span>
                    </div>
                </div>
            </div>
            <!-- <div class="participated" v-if="uncommitted[0] && uncommitted[0].state == '1'">
                <div>
                    <span class="share-nums">{{uncommitted[0].nums == 0 ? "" : uncommitted[0].orderNum}}</span>
                    <img :src="uncommitted[0].coverImg || require('../assets/img/default-coverimg.png')" alt="">
                    <span class="name">{{uncommitted[0].nickName || "用户" + openId.substring(openId.length-6)}}</span>
                </div>
                <span class="ranking-nums">{{uncommitted[0].nums}}</span>
            </div>
            <div :class="uncommitted[0].orderNum > 50 && uncommitted[0].orderNum < 3001?'prize':'prize prizes'" v-if="uncommitted[0] && uncommitted[0].state == '1' && uncommitted[0].nums > 0">
              <div class="prize-left" v-if="uncommitted[0].rank && uncommitted[0].orderNum < 3001">
                <img src="../assets/img/xingxing.png" alt="">
                <p>{{uncommitted[0].rank}}</p>
              </div>
              <div :class="uncommitted[0].orderNum < 3001 ? 'prize-right' : 'prize-right prize-rights'" v-if="uncommitted[0].orderNum > 50">
                <img src="../assets/img/juxing.png" alt="" v-if="uncommitted[0].orderNum < 3001">
                <p>
                    <span v-if="uncommitted[0].orderNum > 50 && uncommitted[0].orderNum < 301" >您距离中国品鉴之星还差</span>
                    <span v-else-if="uncommitted[0].orderNum > 300 && uncommitted[0].orderNum < 3001" >您距离省级品鉴之星还差</span>
                    <span v-else >您距离地区品鉴之星还差</span>
                    <span class="prize-num">{{uncommitted[0].gap == 0 ? 1 : uncommitted[0].gap}}</span>个赞</p>
              </div>
            </div> -->
        </div>
        <!-- 排名列表 -->
        <div class="list">
            <div class="table-title">
                <span>昵称</span>
                <span>集星总量</span>
                <span>排行</span>
            </div>
            <ul class="table-list" v-if="list.length > 0">
                <!-- <md-scroll-view
            ref="scrollView"
            :scrolling-x="false"
            :auto-reflow="true"
          > -->
                <template v-for="(item, index) in list">
                    <li class="item" :key="item.id">
                        <p class="item-name">
                            <img :src="item.coverImg || require('../assets/img/default-coverimg.png')" alt="">
                            <span>{{item.nickName || "用户" + item.openId.substring(item.openId.length-6)}}</span>
                        </p>
                        <span class="item-nums">{{tranNumber(item.nums || 0, 1)}}</span>
                        <p class="item-sort" :style="item.nums <= 0 ? 'opacity: 0' : 'opacity: 1'">
                            <img v-if="index == 0" class="sort-img" src="../assets/img/rankingimg/ranking-1.png" alt="1">
                            <img v-if="index == 1" class="sort-img" src="../assets/img/rankingimg/ranking-2.png" alt="2">
                            <img v-if="index == 2" class="sort-img" src="../assets/img/rankingimg/ranking-3.png" alt="3">
                            <span v-if="index > 2">{{tranNumber(index+1 || 0, 1)}}</span>
                        </p>
                    </li>
                </template>
                <p class="list-tips">
                    <!-- <i></i> -->
                    <span>--已经到底--</span>
                    <span>仅显示前50名</span>
                    <!-- <i></i> -->
                </p>
                <!-- </md-scroll-view> -->
            </ul>

            <div class="no-data-tip" v-else>
                <img v-if="acquisitionTime != 3" src="../assets/img/rankingimg/no-data.png" alt="没数据" />
                <p v-if="acquisitionTime != 3">暂无排名...</p>
                <p v-if="acquisitionTime == 3" class='tip-title'>---飞鹤品鉴PK赛，赢千元大奖活动---</p>
                <p v-if="acquisitionTime == 3" >即将开始，敬请期待。</p>
            </div>

        </div>

    </div>
    <!-- 规则弹窗 -->
    <!-- 首次进入页面规则弹窗 -->
    <div class="msg" v-if="msgFlag">
        <div class="msg-content">
            <index-Msg></index-Msg>
        </div>
        <img @click="msgFlag = false" class="close-msg" src="../assets/img/rankingimg/close-icon.png" alt />
    </div>
    <!-- 注册弹窗 -->
    <md-popup v-model="isPopupShow" :mask-closable="false">
        <div class="register-box">
            <div class="register-info">
                <!-- <p class="register-item">
            <span class="name-icon"></span>
            <input
              type="text"
              placeholder="姓名"
              :value="registerinfo.name"
              @input="e => registerinfo.name = checkname(e)"
              maxlength="10"
            />
          </p> -->
                <md-input-item ref="input0" title="" placeholder="姓名" type="text" v-model.trim="registerinfo.name" :maxlength="10" class="register-item">
                    <span class="name-icon" slot="left"></span>
                </md-input-item>

                <p class="register-item register-item-native">
                    <span class="phone-icon"></span>
                    <input type="tel" v-model="registerinfo.phone" @input="registerinfo.phone = registerinfo.phone.replace(/[^\d]/g,'')" placeholder="手机号" maxlength="11" @focus="inpFocus()" @blur="inpBlur()" />
                </p>

                <p class="register-item register-item-native">
                    <span class="verification-icon"></span>
                    <input type="tel" v-model="registerinfo.verification" @input="registerinfo.verification = registerinfo.verification.replace(/[^\d]/g,'')" placeholder="验证码" maxlength="6" @focus="inpFocus()" @blur="inpBlur()" />
                    <span class="getverification-btn" :class="{'disabled-btn' : !registerinfo.phone}" v-if="countdown == 60" @click.stop="getverification">获取验证码</span>
                    <span class="getverification-btn disabled-btn" v-else>{{countdown}}s</span>
                </p>

                <!-- <md-input-item
            type="digit"
            v-model="registerinfo.verification"
            placeholder="验证码"
            :maxlength="6"
            class="register-item"
          >
            <span class="verification-icon" slot="left"></span>
            <span class="getverification-btn" :class="{'disabled-btn' : !registerinfo.phone}" v-if="countdown == 60" slot="right" @click="getverification">获取验证码</span>
            <span slot="right" class="getverification-btn disabled-btn" v-else>{{countdown}}s</span>
          </md-input-item> -->
                <div class="confrim-btn" :class="{'disabled-confrim-btn': !registerinfo.name || !registerinfo.phone || !registerinfo.verification || !isChecked}">
                    <img @click.stop="confrimregister" src="../assets/img/rankingimg/register-confrim1.png" alt="">
                </div>
                <div class="infor_agreement">
                    <img v-if="!isChecked" @click="isChecked = true" src="../assets/img/rankingimg/no-checked.png" alt="">
                    <img v-else @click="isChecked = false" src="../assets/img/rankingimg/checked.png" alt="">
                    <span class="infor_explain">注册即同意<a @click="goregisterAgreement">用户协议及隐私政策</a>，请仔细阅读说明</span>
                </div>
            </div>
            <div class="close-box">
                <img @click="isPopupShow = false" src="../assets/img/rankingimg/close-icon.png" alt="">
            </div>
        </div>
    </md-popup>

</div>
</template>

<script>
import {
    Popup,
    ScrollView,
    ScrollViewMore,
    InputItem,
    Toast,
} from "mand-mobile";
import {
    getJSSDK
} from "@/assets/utils/jssdk.js";
import indexMsg from "@/components/indexMsg.vue";
import {
    tranNumber,
    getUrlParms,
    getCookie
} from "@/assets/utils/common";

export default {
    name: 'rankingList',
    data() {
        return {
            uncommitted: false, //是否参与排行榜
            list: [], // 排行榜列表
            isPopupShow: false, // 弹窗开关
            registerinfo: {
                phone: '',
                verification: '',
                name: '',
            },
            countdown: 60, // 倒计时60s
            isChecked: false,
            clickCount: 0,
            openId: getCookie("openId"),
            isCanScroll: false,
            acquisitionFlag: false,
            acquisitionTime: "", //活动是否开始结束
            startTime: "",//活动开始时间
            endTime: "",//活动结束时间
            inform: "",//福利通知
            msgFlag: false,//规则弹窗
            prizeList: [],//奖品列表
        }
    },
    components: {
        [ScrollView.name]: ScrollView,
        [ScrollViewMore.name]: ScrollViewMore,
        [Popup.name]: Popup,
        [InputItem.name]: InputItem,
        indexMsg
    },
    created(){
      sessionStorage.setItem('moveAdjustmentFlag',1)
    // location.href.indexOf("active.feihe.com") >= 0 ? gio("init", "8a280edd3fe6d7e0", {}) : gio("init", "ac853984fcde2e20", {})
    // gio('config', {'hashtag':true});
    // gio("send");
    },
    mounted() {
        window.onresize = () => {};
        // window.removeEventListener('resize', () => {}, false)
        this.getlist();
        this.acquisItion();
        getJSSDK(location.href.replace('#/rankingList', ""));
    },
    methods: {
        tranNumber,
        //活动是否开始结束
        acquisItion() {
          // activeStatus /1:在时间范围内,2:不在时间范围内
          this.$axios
                .get("/fission-video/fissionVideo/acquisitionTime")
                .then((res) => {
                  console.log(res,'resss')
                  // this.acquisitionTime = res.obj.activeStatus;//范围
                  this.startTime = res.obj.startTime.trim().split(" ");
                  this.endTime = res.obj.endTime.trim().split(" ");
                  var date = new Date();
                  var seperator1 = "-";
                  var seperator2 = ":";
                  var month = date.getMonth() + 1<10? "0"+(date.getMonth()         + 1):date.getMonth() + 1;
                  var strDate = date.getDate()<10? "0" + date.getDate():date.getDate();
                  var currentdate = date.getFullYear() + seperator1  + month  + seperator1  + strDate
                          + " "  + date.getHours()  + seperator2  + date.getMinutes()
                          + seperator2 + date.getSeconds();
                  console.log(currentdate,'currentdate')
                  this.prizeList = res.obj.prize
                  if(res.obj.activeStatus == 2) {
                    this.acquisitionFlag = true
                    if(this.startTime > currentdate && currentdate > this.endTime) {
                      this.acquisitionTime = 4
                      console.log('活动已结束')
                    }
                    if(currentdate < this.startTime && currentdate < this.endTime) {
                      this.acquisitionTime = 3
                      console.log('活动未开始')
                    }
                  }else {
                    this.acquisitionTime = 1
                    this.acquisitionFlag = false
                  }

                })
                .catch((error) => {
                });
        },
        inpFocus() {
            window.scroll(0, 0)
        },
        inpBlur() {
            window.scroll(0, 0)
        },
        // 进入规则页面
        gopage() {
            this.msgFlag = true
        },
        //用户协议
        goregisterAgreement() {
            this.$router.push({
                path: '/registerAgreement'
            });
        },
        // 后退到首页
        goback() {
            this.$router.go(-1)
            // this.$router.replace({path:'/'});
        },
        // 获取排行榜列表
        getlist() {
            this.$axios.post("/fission-video/fissionVideo/shareRanking", {}).then(res => {
                if (res.status === "0") {
                    console.log(res,'res')
                    if(res.obj == 'null' ) {
                      this.list = res.obj.ranking || [];
                      this.uncommitted = [
                        {
                          coverimg: null,
                          nickName: null,
                          state:0
                        }
                      ]
                    }else{
                      this.uncommitted = res.obj.currentUser;
                      this.list = res.obj.ranking
                    }
                    console.log(this.list,'this.list')
                    console.log(this.uncommitted,'this.uncommitted')
                    sessionStorage.setItem("urlIndex", 1)
                } else {
                    Toast({
                        content: (res && res.msg.toString()) || "获取列表失败",
                        duration: 2000,
                        hasMask: true
                    });
                }
            }).catch(error => {
                Toast({
                    content: (error && error.toString()) || "获取列表失败",
                    duration: 2000,
                    hasMask: true
                });
            });
        },
        //获取验证码
        getverification() {
            if (this.countdown < 60) {
                return;
            }
            let timer = null;
            if (!this.registerinfo.phone) {
                // Toast({
                //   content: "请输入手机号",
                //   duration: 2000,
                //   hasMask: true
                // });
                return false;
            }

            var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if (!myreg.test(this.registerinfo.phone)) {
                Toast({
                    content: "请输入正确的手机号",
                    duration: 2000,
                    hasMask: true
                });
                return false;
            }

            this.clickCount++;
            if (this.clickCount > 1) {
                return false;
            }

            this.$axios.post("/fission-video/fissionVideo/getVerification", {
                phone: this.registerinfo.phone
            }).then(res => {
                this.clickCount = 0;
                Toast({
                    content: "验证码发送成功",
                    duration: 2000,
                    hasMask: true
                });
                this.countdown--;

                timer = setInterval(() => {
                    this.countdown--;
                    if (this.countdown == 1) {
                        this.countdown = 60;
                        clearInterval(timer)
                    }
                }, 1000)
            }).catch(error => {
                this.clickCount = 0;
                Toast({
                    content: (error && error.toString()) || "获取列表失败",
                    duration: 2000,
                    hasMask: true
                });
            })

        },
        // 确认注册
        confrimregister() {
            var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            var namereg = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/;
            if (!this.registerinfo.name) {
                return false;
                // Toast({
                //   content: "请输入姓名",
                //   duration: 2000,
                //   hasMask: true
                // });
            } else if (!namereg.test(this.registerinfo.name)) {
                Toast({
                    content: "请输入正确的姓名",
                    duration: 2000,
                    hasMask: true
                });
                return false;

            }
            if (!this.registerinfo.phone) {
                return false;
                //  Toast({
                //   content: "请输入手机号",
                //   duration: 2000,
                //   hasMask: true
                // });
            } else if (!myreg.test(this.registerinfo.phone)) {
                Toast({
                    content: "请输入正确的手机号",
                    duration: 2000,
                    hasMask: true
                });
                return false;
            }

            if (!this.registerinfo.verification) {
                return false;
                // Toast({
                //   content: "请输入验证码",
                //   duration: 2000,
                //   hasMask: true
                // });
            } else if (this.registerinfo.verification.length != 6) { //验证码不正确
                return Toast({
                    content: "验证码错误",
                    duration: 2000,
                    hasMask: true
                });
            }

            if (!this.isChecked) {
                return false;
                // Toast({
                //   content: "请勾选用户协议及隐私政策",
                //   duration: 2000,
                //   hasMask: true
                // });
            }

            this.clickCount++;
            if (this.clickCount > 1) {
                return false;
            }

            this.$axios.post("/fission-video/fissionVideo/userRegistration", this.registerinfo).then(res => {
                console.log(res)
                this.clickCount = 0;
                Toast({
                    content: res.msg.toString() || "注册成功",
                    duration: 2000,
                    hasMask: true
                });
                this.isPopupShow = false;
                this.getlist();

            }).catch(error => {
                this.clickCount = 0;
                Toast({
                    content: (error && error.toString()) || "注册失败",
                    duration: 2000,
                    hasMask: true
                });
            })
        },
        //参与活动
        popupShow() {
            this.clickCount++;
            if (this.clickCount > 1) {
                return false;
            }
            this.$axios.post("/fission-video/fissionVideo/participate", {}).then(res => {
                this.clickCount = 0;
                // 老用户点击参与，直接刷新列表
                if (res.obj.status == 0) {
                    this.getlist();
                } else {
                    // 新用户点击参与需要填写信息
                    this.isPopupShow = !this.isPopupShow;
                    this.registerinfo = {
                        phone: '',
                        verification: '',
                        name: '',
                    }
                    this.isChecked = false;
                }
            }).catch(error => {
                this.clickCount = 0;
                Toast({
                    content: (error && error.toString()) || "注册失败",
                    duration: 2000,
                    hasMask: true
                });
            })
        },
        checkname(e) {
            var reg = /[^\u4E00-\u9FA5a-zA-Z0-9]/g;
            const o = e.target;
            console.log(reg.test(o.value))
            if (reg.test(o.value)) {
                o.value = o.value.replace(reg, '');
                return o.value;
            }
            // o.value = o.value.replace(reg, ''); // 清除除了中文以外的输入的字符
            // this.registerinfo.name = o.value;
        }
    },
}
</script>

<style lang="less" scoped>
.ranking-list {
    width: 100%;
    height: 100%;
    overflow: auto;
    overflow-x: hidden;
    background: #fff;
     // 规则弹窗
    .msg {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.7);
        z-index: 9999;
        display: flex;
        flex-direction: column;
    }

    .msg-content {
        width: 662px;
        height: 988px;
        background: url("../assets/img/jianglimsg.png") no-repeat center;
        background-size: 100%;
        margin: 40px auto;
        padding-bottom: 71px;
    }

    .close-msg {
        margin: -30px auto;
        width: 50px;
        height: 50px;
        z-index: 9999;
    }
    .top-three-box {
        position: relative;
        z-index: 1;
        height: 801px;
        background: url(../assets/img/rankingimg/ranking-bg.png) no-repeat 0 0;
        background-size: 100%;

        .back {
            position: absolute;
            left: 25px;
            top: 38px;
            width: 22px;
            height: 38px;
            background: url(../assets/img/back.png) no-repeat 0 0;
            background-size: 100% 100%;
        }

        .top-pklogo {
            width: 272px;
            height: 58px;
            background: url('../assets/img/rankingimg/pklogo.png') no-repeat center;
            background-size: 100%;
            position: absolute;
            top: 43px;
            left: 243px;
        }

        .rewardrules-enter {
            position: absolute;
            right: -100px;
            top: 69px;
            width: 300px;
            height: 98px;
            background: url('../assets/img/rankingimg/rewardrules-icon1.png') no-repeat center;
            background-size: cover;
        }

        .top-ranking {
          width: 616px;
          height: 500px;
          background: url('../assets/img/rankingimg/top-ranking.png') no-repeat center;
          background-size: 100%;
          position: absolute;
          top: 120px;
          left: 67px;
          color: #FFA113;
          font-size: 24px;
          .top-rankingItem:first-child {
            width: 210px;
            position: absolute;
            top: 120px;
            left: 200px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img {
              width: 150px;
              height: 154px;
            }
            p {
              width: 150px;
            }
          }
          .top-rankingItem:nth-child(2) {
            width: 210px;
            position: absolute;
            top: 150px;
            left: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img {
              width: 129px;
              height: 154px;
            }
            p {
              width: 160px;
            }
          }
          .top-rankingItem:nth-child(3) {
            width: 210px;
            position: absolute;
            top: 150px;
            right: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img {
              width: 129px;
              height: 154px;
            }
            p {
              width: 160px;
            }
          }
          // .top-rankingItem:nth-child(4) {
          //   width: 210px;
          //   position: absolute;
          //   top: 150px;
          //   right: 0;
          //   display: flex;
          //   flex-direction: column;
          //   justify-content: center;
          //   align-items: center;
          //   img {
          //     width: 129px;
          //     height: 154px;
          //   }
          //   p {
          //     display: flex;
          //     flex-direction: column;
          //     justify-content: center;
          //     align-items: center;
          //   }
          // }
        }

        .rule-entrance {
            position: absolute;
            top: 30px;
            right: 0;
            padding: 0 20px;
            border: 1px solid #ddd;
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
        }

        .top-one,
        .top-two,
        .top-three {
            position: absolute;
            width: 180px;
            text-align: center;
            // padding: 40px 17px 0;

            img {
                width: 146px;
                height: 146px;
                border-radius: 50%;
                overflow: hidden;
                margin: 40px auto 32px;
            }

            .top-name {
                width: 100%;
                margin-bottom: 24px;
                font-size: 32px;
                font-weight: 500;
                color: #FFF;
                line-height: 34px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }

            .top-nums {
                position: relative;
                font-size: 36px;
                font-weight: 500;
                color: #FF7F14;
                padding-top: 54px;
                line-height: 56px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;

                &::before {
                    position: absolute;
                    top: 0;
                    left: 50%;
                    margin-left: -26px;
                    content: "";
                    width: 52px;
                    height: 52px;
                    display: block;
                    background: url(../assets/img/rankingimg/zan-icon.png) no-repeat center center;
                    background-size: 100% 100%;
                }
            }

            .no-data {
                display: flex;
                align-items: center;
                width: 126px;
                height: 176px;
                margin: 0 auto;
                padding: 15px 35px 0;
                font-size: 26px;
                font-weight: 400;
                color: #FFF;
                line-height: 34px;
            }
        }

        .top-two,
        .top-three {
            width: 156px;

            img {
                width: 126px;
                height: 126px;
                margin: 35px auto;
            }
        }

        .top-one {
            top: 79px;
            left: calc(50% - 90px);
            background: url(../assets/img/rankingimg/champion-icon.png) no-repeat 0 0;
            background-size: 100% auto;

            .no-data {
                height: 203px;
            }
        }

        .top-two {

            top: 205px;
            left: 63px;
            background: url(../assets/img/rankingimg/runner-up-icon.png) no-repeat 0 0;
            background-size: 100% auto;

            .top-nums {
                padding-left: 39px;

                &::before {
                    left: 69px;
                    margin-left: 0;
                }

            }

        }

        .top-three {
            top: 235px;
            right: 63px;
            background: url(../assets/img/rankingimg/thirdplace-icon.png) no-repeat 0 0;
            background-size: 100% auto;

            .top-nums {
                padding-right: 39px;

                &::before {
                    left: 30px;
                    margin-left: 0;
                }

            }
        }
    }

    .ranking-box {
        position: relative;
        z-index: 2;
        width: 100%;
        // height: calc(100% - 660px);
        height: auto;
        margin-top: -300px;
        padding: 39px 30px 16px;
        background: #fff;
        border-radius: 40px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        .prize{
          width: 100%;
          height: 130px;
          margin-top: 10px;
          border-top: 1px solid #dedede;
          display: flex;
          align-items: center;
          justify-content: space-around;
          .prize-left{
            font-size: 28px;
            display: flex;
            color: #000525;
            margin-left: 30px;
            img{
              width: 32px;
              height: 32px;
              margin-right: 10px;
            }
          }
          .prize-right{
            width: 371px;
            height: 54px;
            font-size: 22px;
            color: #989898;
            display: flex;
            img{
              width: 30px;
            }
            .prize-num{
              color:#ffb412;
            }
          }
          .prize-rights{
              width: 100% !important;
              justify-content: center;
          }
        }

        .prizes{
          justify-content: center !important;
        }

        .person-info {
            width: 100%;
            height: 247px;
            box-shadow: 0px 0px 16px 0px rgba(118, 185, 232, 0.27);
            border-radius: 20px;
            padding: 27px 22px 25px 25px;

            div {
                display: flex;
                align-items: center;
                justify-content: space-between;

                img {
                    width: 88px;
                    height: 88px;
                    border-radius: 50%;
                }

                .name {
                    width: 112px;
                    display: inline-block;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    font-size: 30px;
                    line-height: 34px;
                    font-weight: 500;
                    color: #000626;
                    white-space: nowrap;
                }

                .join-btn {
                    display: block;
                    width: 115px;
                    height: 50px;
                    background: linear-gradient(0deg, #FF8814 0%, #FFBA18 100%);
                    border-radius: 10px;
                    font-size: 27px;
                    font-weight: 500;
                    color: #FFF;
                    line-height: 50px;
                    text-align: center;
                }

                .tips {
                    font-size: 26px;
                    font-weight: 400;
                    color: #C5C5C5;
                    line-height: 35px;
                }

                .share-nums {
                    font-size: 28px;
                    font-weight: 500;
                    color: #A0A0A0;
                    line-height: 34px;
                    margin-right: 63px;
                }

                .ranking-nums {
                    font-size: 30px;
                    font-weight: 500;
                    color: #000525;
                    line-height: 50px;
                }
            }



            .participated {

                // display: block;
                img {
                    margin-right: 20px;
                }
            }

        }
        .person-infos {
          width: 100%;
          height: 270px;
          // box-shadow: 0px 0px 16px 0px rgba(118, 185, 232, 0.27);
          border-radius: 20px;
          padding: 27px 25px 25px 25px;
          background: url('../assets/img/person-infos.png') center no-repeat;
          background-size: cover;
          .uncommitted {
              width: 100%;
              height: 100%;
              .activity-time {
                width: 100%;
                height: 100px;
                text-align: left;
                color:#fff;
                line-height: 100px;
                display: flex;
                align-items: center;
                .join-btn {
                    display: block;
                    width: 115px;
                    height: 50px;
                    background: linear-gradient(0deg, #FF8814 0%, #FFBA18 100%);
                    border-radius: 10px;
                    font-size: 27px;
                    font-weight: 500;
                    color: #FFF;
                    line-height: 50px;
                    margin-left: 60px;
                    text-align: center;
                }
              }
              .division {
                width: 100%;
                height: 1px;
                background: #B95E0F;
                opacity: 0.15;
              }
              .uncommitted-container {
                  height: 126px;
                  display: flex;
                  align-items: center;
                  font-size: 30px;
                  color: #fff;
                  img {
                      width: 88px;
                      height: 88px;
                      border-radius: 50%;
                  }
                  .ucontainer-left {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    margin-right: 10px;
                    width: 42%;
                    img {
                      width: 88px;
                      height: 88px;
                      margin-right: 18px;
                    }
                    .name {
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      text-align: left;
                    }
                  }
                  .ucontainer-right {
                    flex: 1;
                    display: flex;
                    justify-content: space-around;
                  }
              }
          }

            .participated {
              width: 100%;
              height: 100%;
              .division {
                width: 100%;
                height: 1px;
                background: #B95E0F;
                opacity: 0.15;
              }
              .participated-top {
                width: 100%;
                height: 100px;
                text-align: left;
                color:#fff;
                font-size: 28px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .activity-time {
                  width: 100%;
                  height: 100px;
                  text-align: left;
                  color:#fff;
                  line-height: 100px;
                  display: flex;
                  align-items: center;
                  .join-btn {
                      display: block;
                      width: 115px;
                      height: 50px;
                      background: linear-gradient(0deg, #FF8814 0%, #FFBA18 100%);
                      border-radius: 10px;
                      font-size: 27px;
                      font-weight: 500;
                      color: #FFF;
                      line-height: 50px;
                      margin-left: 60px;
                      text-align: center;
                  }
                }
                .division {
                  width: 100%;
                  height: 1px;
                  background: #B95E0F;
                  opacity: 0.15;
                }
                .pratLenf-Container {
                  width: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  .partLeft {
                    img {
                      width: 44px;
                      height: 48px;
                    }
                  }
                  .partRight {
                    margin-left: 5px;
                    border-radius: 39px;
                    opacity: .18;
                    width: 336px;
                    height: 59px;
                    background: linear-gradient(90deg, #FFD8B3 0%);
                    p {
                      color: #ffffff;
                      font-weight: 400;
                    }
                  }
                  .partRight-text {
                    opacity: .8;
                    font-size: 22px;
                    position: absolute;
                    left: 380px;
                    .prize-num {
                      color: #FFE85C;
                    }
                  }
                }
              }
              .participated-bottom {
                height: 126px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 30px;
                color: #fff;
                img {
                  width: 88px;
                  height: 88px;
                  border-radius: 50%;
                }
                .participated-left {
                    width: 42%;
                    display: flex;
                    align-items: center;
                    margin-right: 57px;
                    img {
                      width: 88px;
                      height: 88px;
                      margin-right: 26px;
                    }
                    .name {
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                    }
                  }
                  .participated-right {
                    flex: 1;
                    display: flex;
                    justify-content: space-around;
                  }
              }
                // display: block;
                img {
                    margin-right: 20px;
                }

            }
        }
        .list {
            height: calc(100% - 140px);
            padding-top: 29px;

            .table-title {
                width: 100%;
                padding: 40px 0 20px 0;
                display: flex;
                justify-content: space-between;
                span {
                    height: 34px;
                    font-size: 28px;
                    font-weight: 400;
                    color: #8F98A3;
                    line-height: 34px;

                    // &:first-child {
                    //     padding: 0 24px;
                    //     margin-right: 65px;
                    // }

                    // &:nth-child(2) {
                    //     padding: 0 120px;
                    // }

                    &:last-child {
                        // float: right;
                        padding: 0 38px 0 0;
                    }
                }
            }

            .table-list {
                height: calc(100% - 110px);
                overflow: auto;

                .item {
                    display: flex;
                    padding: 20px 0;

                    .item-sort {
                        display: inline-block;
                        width: 100px;
                        height: 88px;
                        margin-left: 158px;
                        // padding: 0 24px;
                        text-align: center;
                        font-size: 28px;
                        font-weight: 500;
                        color: #A0A0A0;
                        line-height: 88px;

                        .sort-img {
                            width: 53px;
                            height: 61px;
                        }
                    }

                    .item-name {
                        width: calc(100% - 165px - 260px);
                        // flex: 1;
                        display: inline-block;

                        img {
                            width: 88px;
                            height: 88px;
                            border-radius: 50%;
                            margin-right: 15px;
                        }

                        span {
                            display: inline-block;
                            vertical-align: top;
                            width: 120px;
                            line-height: 88px;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                        }

                    }

                    .item-nums {
                        display: inline-block;
                        width: 150px;
                        color: #000525;
                        font-weight: 500;
                        padding-right: 19px;
                        line-height: 88px;
                        text-align: center;
                    }
                }

                .list-tips {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 30px 0;
                    text-align: center;
                    flex-direction: column;

                    span {
                        display: block;
                        font-size: 24px;
                        font-weight: 400;
                        color: #C5C5C5;
                        line-height: 34px;

                    }

                    i {
                        display: block;
                        width: 112px;
                        height: 1px;
                        margin: 0 20px;
                        background: #C5C5C5;
                    }

                }

            }

        }

        .no-data-tip {
            width: 100%;
            height: calc(100% - 103px);

            img {
                display: block;
                width: 170px;
                height: auto;
                margin: 40px auto;
            }

            .tip-title {
              margin-top: 100px;
            }

            p {
                text-align: center;
                color: #333;
                font-size: 24px;
                font-weight: 400;
                line-height: 36px;
            }
        }
    }

    .register-box {
        width: 545px;
        padding: 130px 0 65px;
        background: url(../assets/img/rankingimg/register-bg.png) no-repeat;
        background-size: 100% auto;

        .register-info {
            padding-bottom: 48px;

            .register-item {
                width: 460px;
                height: 69px;
                border: 1px solid #CBCBCB;
                border-radius: 36px;
                margin: 0 auto 30px;

                .name-icon {
                    width: 24px;
                    height: 32px;
                    background: url(../assets/img/rankingimg/my-name.png) no-repeat;
                    background-size: 100% auto;
                }

                .phone-icon {
                    display: inline-block;
                    width: 24px;
                    height: 29px;
                    margin-left: 32px;
                    background: url(../assets/img/rankingimg/phone.png) no-repeat;
                    background-size: 100% auto;
                }

                .verification-icon {
                    display: inline-block;
                    width: 20px;
                    height: 32px;
                    margin-left: 32px;
                    background: url(../assets/img/rankingimg/verification-icon.png) no-repeat;
                    background-size: 100% auto;

                }

                .getverification-btn {
                    width: 180px;
                    height: 69px;
                    margin-right: -1px;
                    color: #fff;
                    font-size: 24px;
                    line-height: 69px;
                    text-align: center;
                    background: #FF7D13;
                    border-radius: 36px;
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                }

                .disabled-btn {
                    background: #C6C6C6;

                }

            }

            .register-item-native {
                display: flex;
                align-items: center;
                overflow: hidden;

                input {
                    flex: 1;
                    height: 100%;
                    padding: 0 14px;
                    font-size: 26px;
                    font-weight: 400;
                    color: #333;
                }

            }

            .confrim-btn {
                width: calc(100% - 52px);
                margin: 0 auto;
                border-radius: 36px;

                img {
                    width: 100%;
                    height: auto;
                }
            }

            .disabled-confrim-btn {
                filter: grayscale(100%);
            }

            .infor_agreement {
                display: flex;
                // align-items: inherit;
                width: 460px;
                margin: 0 auto;
                font-weight: 400;
                line-height: 34px;
                font-size: 20px;
                color: #BABABA;

                img {
                    width: 22px;
                    height: 22px;
                    margin-right: 10px;
                    margin-top: 5px;
                }
            }
        }

        .close-box {
            width: 65px;
            padding-top: 82px;
            margin: 0 auto;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}

@media screen and (orientation: landscape) {
    .ranking-list {
        overflow: auto;

        .ranking-box {
            height: auto;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/rankingList.vue